import { Component, OnInit } from '@angular/core';
import { FeaturesService } from '@libraries/feature-flags';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: { class: 'prequal-theme' },
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private features: FeaturesService) {}
  ngOnInit() {
    const variation = this.features.isOn('yt-13358-prequal-calculator') ? 'Variation 1' : 'Control';
  }
}
